/* eslint-disable indent */
import React from 'react';
import tw from 'tailwind-styled-components';
import { PageLayout } from '../../components/Layout/PageLayout';
import { MobileAppDownloadBanner } from '../../components/MobileAppDownloadBanner/MobileAppDownloadBanner';
import { markdownToHtml } from '../../services/markdown';
import { renderSection } from '../../services/section';
import {
  FooterSectionType,
  NavigationBarType,
  PageSectionType,
  PreFootersType,
} from '../../types';
import { PreFooterTypesSection } from '../components/Sections/PreFooterTypesSection';

interface PageInfoProps {
  navBarSection: PageSectionType<NavigationBarType>;
  footerSection: PageSectionType<FooterSectionType>;
  preFooterType?: PreFootersType;
  title: string;
  content: string;
}

export function PageInfo(props: PageInfoProps): JSX.Element {
  const { title, content, navBarSection, footerSection, preFooterType } = props;
  return (
    <PageLayout>
      {renderSection(navBarSection)}
      <MobileAppDownloadBanner />
      <Article>
        <Title>{title}</Title>
        <Content
          dangerouslySetInnerHTML={{
            __html: markdownToHtml(content),
          }}
          className='prose break-words'
        />
      </Article>
      {preFooterType && <PreFooterTypesSection data={preFooterType} />}
      {renderSection(footerSection)}
    </PageLayout>
  );
}

const Article = tw.div`
grid px-24 lg:px-4 w-full
content-center justify-center
`;

const Title = tw.h1`
w-full min-w-full 
text-center
text-xl
my-8
`;

const Content = tw.p`
w-full min-w-full
pb-20
`;
